module.exports = __webpack_public_path__ + "static/media/address.61851116.svg";